var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10726_54591)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.45456 21.8403V12.5674L2.57878 9.93653L0 8.47656V20.2038C0 21.1093 0.733594 21.8403 1.63641 21.8403H5.45456Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5454 21.8402H22.3636C23.2691 21.8402 24 21.1065 24 20.2037V8.47656L21.0791 10.1488L18.5454 12.5673V21.8402Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.45479 12.5674L5.06348 8.94428L5.45479 5.47656L12.0002 10.3857L18.5457 5.47656L18.9834 8.75706L18.5457 12.5674L12.0002 17.4766L5.45479 12.5674Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5454 5.47691V12.5678L24 8.47691V6.29506C24 4.27147 21.69 3.11788 20.0728 4.33147L18.5454 5.47691Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 8.47695L2.50866 10.3585L5.45456 12.5678V5.47695L3.92719 4.33151C2.30719 3.11783 0 4.27151 0 6.29501V8.47695Z",
    fill: "#C5221F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10726_54591"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.835938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmailIcon);
export default __webpack_public_path__ + "static/media/GmailIcon.d19363d09cc1fa135fbb211898ce71a0.svg";
export { ForwardRef as ReactComponent };